export const additionalFormChoice: Record<string, string> = {
  spouse_deduction: '配偶者(特別)控除額',
  spouse_income: '配偶者の合計所得',
  new_life_insurance: '新生命保険料',
  old_life_insurance: '旧生命保険料',
  care_insurance: '介護医療保険料',
  new_personal_pension_insurance: '新個人年金保険料',
  old_personal_pension_insurance: '旧個人年金保険料',
};
